











































import { appModule } from "@/store/modules/app";
// import { storePresensi } from "@/store/modules/presensi";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import UnitAllAutoComplete from "@/components/UnitAllAutoComplete.vue";
import DataBed from "@/services/DataBed";
import { storeReferensi } from "@/store/modules/referensi";
import { storeBed } from "@/store/modules/bed";
import { userModule } from "@/store/modules/user";
@Component({
  components: {
    UnitAllAutoComplete,
  },
})
export default class ModalBatalMondok extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() item!: object;
  // @Prop() bulan: string;
  // jam = "jam";
  // validasi = [(v) => this.cek(v) || this.message()];
  // valid = [(v) => !!v || "*Alasan harus diisi"];
  unitAll = {};

  simpan() {
    const dt = DataBed.batalMondok(
      this.item["id"],
      this.unitAll["id"],
      this.user["pegawai_id"]
    );
    dt.then((dt) => {
      if (dt["status"] != 1) {
        appModule.sendErrorAlert(dt["message"]);
      } else {
        appModule.NoticeDelay("Berhasil Batal Mondok Pasien");
        // storeBed.actBedByUnit(this.item["unit"].id);
        this.close();
      }
    });
  }

  setUnitAll(val) {
    this.unitAll = val;
  }

  close() {
    storeBed.actBedByUnit(this.item["unit"].id);
    this.unitAll = {};
    this.show = false;
  }

  get user() {
    return userModule.user;
  }

  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }
}
